'use strict';

import { User } from '../User/User';
import { Entity } from '../Entity';
import { StaffSignatureEmail } from './StaffSignatureEmail';
import { IpList } from '../IpList';
import { IpListCollection } from '../../Collections/IpListCollection';

export class Staff extends Entity {
  protected staffId: number;
  protected staffFirstname: string;
  protected staffLastname: string;
  protected staffUsername: string;
  protected staffPhone: string;
  protected ips;

  protected signatureEmail;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.staffId = data.staffId;
    this.staffFirstname = data.staffFirstname;
    this.staffLastname = data.staffLastname;
    this.staffUsername = data.staffUsername;
    this.staffPhone = data.staffPhone;

    if (data.staffEmailSignature) {
      const emailSignature = new StaffSignatureEmail();
      emailSignature.hydrate(data.staffEmailSignature);

      this.signatureEmail = emailSignature;
    }

    if (data.ips) {
      const ips = new IpListCollection();

      data.ips.forEach((singleIpData) => {
        const userIp = new IpList();
        userIp.hydrate(singleIpData);

        ips.addItem(userIp);
      });

      this.ips = ips;
    }
  }

  public getStaffId() {
    return this.staffId;
  }

  public getStaffFirstname() {
    return this.staffFirstname;
  }

  public getStaffLastname() {
    return this.staffLastname;
  }

  public getStaffUsername() {
    return this.staffUsername;
  }

  public getStaffPhone() {
    return this.staffPhone;
  }

  public getSignatureEmail() {
    return this.signatureEmail;
  }

  public getIps() {
    return this.ips;
  }
}
